import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./~/rc-notification/es/index.js
// module id = 626
// module chunks = 3